import React, { Component } from 'react';

class CheckBox extends Component {
  render() {
    const { handleChange, type, value, label } = this.props;
    return (
      <label className="btn btn-primary btn-checkbox" data-toggle="buttons">
        <input
          onChange={handleChange}
          defaultChecked={value}
          type="checkbox"
          name={type}
          value={type}
        />
        &nbsp;
        {label}
      </label>
    );
  }
}

export default CheckBox;
